import { createSelector } from 'reselect'

export const getItems = createSelector(
  (state) => state.items,
  items => items
);

export const getFilters = createSelector(
  (state) => state.products,
  ({filters}) => filters
);

export const getCount = createSelector(
  (state) => state.products.total_count,
  (total_count) => total_count
);

export const getFiltersSchema = createSelector(
  (state) => state.products,
  ({filtersSchema}) => filtersSchema
);

